(function(funcName, baseObj) {
    // The public function name defaults to window.docReady
    // but you can pass in your own object and own function name and those will be used
    // if you want to put them in a different namespace
    funcName = funcName || "docReady";
    baseObj = baseObj || window;
    var readyList = [];
    var readyFired = false;
    var readyEventHandlersInstalled = false;
  
    // call this when the document is ready
    // this function protects itself against being called more than once
    function ready() {
        if (!readyFired) {
            // this must be set to true before we start calling callbacks
            readyFired = true;
            for (var i = 0; i < readyList.length; i++) {
                // if a callback here happens to add new ready handlers,
                // the docReady() function will see that it already fired
                // and will schedule the callback to run right after
                // this event loop finishes so all handlers will still execute
                // in order and no new ones will be added to the readyList
                // while we are processing the list
                readyList[i].fn.call(window, readyList[i].ctx);
            }
            // allow any closures held by these functions to free
            readyList = [];
        }
    }
    function readyStateChange() {
        if ( document.readyState === "complete" ) {
            ready();
        }
    }
    // This is the one public interface
    // docReady(fn, context);
    // the context argument is optional - if present, it will be passed
    // as an argument to the callback
    baseObj[funcName] = function(callback, context) {
        if (typeof callback !== "function") {
            throw new TypeError("callback for docReady(fn) must be a function");
        }
        // if ready has already fired, then just schedule the callback
        // to fire asynchronously, but right away
        if (readyFired) {
            setTimeout(function() {callback(context);}, 1);
            return;
        } else {
            // add the function and context to the list
            readyList.push({fn: callback, ctx: context});
        }
        // if document already ready to go, schedule the ready function to run
        if (document.readyState === "complete") {
            setTimeout(ready, 1);
        } else if (!readyEventHandlersInstalled) {
            // otherwise if we don't have event handlers installed, install them
            if (document.addEventListener) {
                // first choice is DOMContentLoaded event
                document.addEventListener("DOMContentLoaded", ready, false);
                // backup is window load event
                window.addEventListener("load", ready, false);
            } else {
                // must be IE
                document.attachEvent("onreadystatechange", readyStateChange);
                window.attachEvent("onload", ready);
            }
            readyEventHandlersInstalled = true;
        }
    };
  })("docReady", window);
  
  // use an anonymous function
  docReady(function() {
    Mmenu.configs.classNames.selected = "active";
    // Mmenu.configs.offCanvas.page.selector = "#my-page";

    new Mmenu( "#mobile-menu", {
      extensions: ["theme-dark", "fullscreen", "position-front", "position-right"],
      navbars: [
        {
           "position": "top",
           "content": [
              "searchfield",
              "close",
           ]
        },
        {
          "position": "bottom",
          "content": [
             "<a href='#/'><i class='fa fa-lg fa-facebook-square' aria-hidden='true'></i></a>",
             "<a href='#/'><i class='fa fa-lg fa-twitter' aria-hidden='true'></i></a>",
             "<a href='#/'><i class='fa fa-lg fa-instagram' aria-hidden='true'></i></a>",
             "<a href='#/'><i class='fa fa-lg fa-linkedin' aria-hidden='true'></i></a>"
          ]
        }
      ],
      searchfield: {
        add: true,
        search: false
      }
    }, {
      // configuration
      classNames: {
        selected: "active"
      },
      searchfield: {
        form: {
          method: "GET",
          action: "/"
        },
        input: {
          name: "s"
        }
      }
    });

    // code here
    Element.prototype.remove = function() {
      this.parentElement.removeChild(this);
    };
    NodeList.prototype.remove = HTMLCollection.prototype.remove = function() {
      for(var i = this.length - 1; i >= 0; i--) {
        if(this[i] && this[i].parentElement) {
          this[i].parentElement.removeChild(this[i]);
        }
      }
    };
    var header = document.querySelector(".main.navbar");
    var headroom  = new Headroom(header, {
      offset: 150,
      tolerance : {
        up : 0,
        down : 0
      },

      // css classes to apply
      classes : {
        // when element is initialised
        initial : "sticky",
        // when scrolling up
        pinned : "sticky--pinned",
        // when scrolling down
        unpinned : "sticky--unpinned",
        // when above offset
        top : "sticky--top",
        // when below offset
        notTop : "sticky--not-top",
        // when at bottom of scoll area
        bottom : "sticky--bottom",
        // when not at bottom of scroll area
        notBottom : "sticky--not-bottom"
      },

      // callback when pinned, `this` is headroom object
      onPin: function() {
        window.isPinned = true;
      },

      // callback when unpinned, `this` is headroom object
      onUnpin: function() {
        window.isPinned = false;
      },
    });
    // initialise
    headroom.init();

    var $searchIcon = Array.prototype.slice.call(document.querySelectorAll('.icon.search'), 0);
    
    if ($searchIcon.length > 0) {
        $searchIcon.forEach(function ($el) {
            var $searchCloseIcon = $el.parentNode.querySelector('.icon.close');            
            $el.addEventListener('click', function (e) {
                if (!$el.classList.contains('is-active')) {
                    $el.nextElementSibling.classList.add('is-active');
                    $el.classList.add('is-active');
                } else {
                    $el.nextElementSibling.querySelector('.search-submit').click();
                }
            });
            if ($searchCloseIcon) {
                $searchCloseIcon.addEventListener('click', function (e) {
                    $el.nextElementSibling.classList.remove('is-active');
                    $el.classList.remove('is-active');
                });
            }
                
        });
    }

    //Clone sidebar for desktop view 
    var $breakSection = document.querySelector('.main[role="document"] .container + section.break-cta');
    var $sidebar = document.querySelector('.main[role="document"] .container:last-child aside.sidebar');
    var $sidebarFirst = document.querySelector('.main[role="document"] .container:first-child .sidebar');
    
    function getOffset(el) {
      el = el.getBoundingClientRect();
      return {
        left: el.left + window.pageXOffset,
        top: el.top + window.pageYOffset
      };
    }
    if ($breakSection) {
        if ($sidebar) {
            var $sidebarClone = $sidebar.cloneNode(true);
            $sidebarClone.classList.remove('is-hidden-desktop');
            $sidebarClone.classList.add('is-hidden-touch');
            $sidebarFirst.appendChild($sidebarClone);
        }

    } else {
        if ($sidebar) {
            $sidebar.classList.remove('is-hidden-desktop');
        }
    }
    if ($sidebarFirst) {
      var $sidebarWidth = $sidebarFirst.clientWidth;
      var $consultationWidget = $sidebarFirst.querySelector(".widget-consultation");
      if ($consultationWidget) {
        $consultationWidget.style.width = $consultationWidget.clientWidth + "px";
        var consultationSticky  = new Headroom($consultationWidget, {
          offset: getOffset($consultationWidget).top - 92,
          tolerance : {
            up : 5,
            down : 5
          },

          // css classes to apply
          classes : {
            // when element is initialised
            initial : "sticky",
            // when scrolling up
            pinned : "sticky--pinned",
            // when scrolling down
            unpinned : "sticky--unpinned",
            // when above offset
            top : "sticky--top",
            // when below offset
            notTop : "sticky--not-top",
            // when at bottom of scoll area
            bottom : "sticky--bottom",
            // when not at bottom of scroll area
            notBottom : "sticky--not-bottom"
          },

          // callback when pinned, `this` is headroom object
          onPin: function() {
            window.isPinned = true;
          },

          // callback when unpinned, `this` is headroom object
          onUnpin: function() {
            window.isPinned = false;
          },
        });
        // initialise
        consultationSticky.init();
      }
      
      if ($consultationWidget) {
        var subscribe = document.querySelector('.subscribe');
        var footer = document.querySelector('.footer');
        window.addEventListener('scroll', function ( event ) {
    
          var widgetPos = ((window.innerHeight - subscribe.getBoundingClientRect().bottom) + $consultationWidget.clientHeight) + 15;
          
          if ((window.pageYOffset + $consultationWidget.clientHeight + 176) > subscribe.offsetTop) {
            $consultationWidget.style.top = 'auto';
            $consultationWidget.style.bottom = (widgetPos) + 'px';
          } else {
            $consultationWidget.style.top = '';
            $consultationWidget.style.bottom = 'auto';
          }
        }, false);
      }
      
    }
  });